import React, { useEffect, useState } from 'react';
import { getUserContentSuggestions } from './utils/contentSuggestions';

export function useContentSuggestions (contentType:string) {

  const [content, setContent] = useState<any>(null)
  const [contentLoaded, setContentLoaded] = useState(false)

  useEffect(() => {
    getUserContentSuggestions(contentType).then((response)=>{
      setContent(response)
      setContentLoaded(true)
    }).catch(()=>{
      setContent([])
      setContentLoaded(true)
    })
  }, []);

  return {
    content, contentLoaded
  }
}